import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../../auth/services/auth.service';

interface HomeAction {
  title: string;
  description: string;
  route: string;
  icon: string;
  actionText: string;
}

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [MatIconModule, RouterLink],
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  readonly user = inject(AuthService).user;

  readonly actions: HomeAction[] = [
    {
      title: 'New Demand',
      description:
        'Start a new application decommissioning or data archival demand.',
      route: '/new',
      icon: 'assignment_add',
      actionText: 'Create new demand',
    },
    {
      title: 'My Demands',
      description: 'View the status and progress of your submitted requests.',
      route: '/demands',
      icon: 'cancel_presentation',
      actionText: 'Go to my demands',
    },
    {
      title: 'My Assignments',
      description: 'Review, update and progress requests assigned to you.',
      route: '/assignments',
      icon: 'archive',
      actionText: 'Go to my assignments',
    },
  ];
}
